export {
  getOptionalPhoneValidationError,
  getRequiredPhoneValidationError,
  normalizePhoneForSubmit,
} from "@ths/shared/utils";

export const onlyDigits = (value: string) => value.replace(/\D/g, "");

const formatUsPhoneDigits = (digits: string) => {
  const nationalDigits = digits.slice(0, 10);

  if (nationalDigits.length <= 3) return nationalDigits;
  if (nationalDigits.length <= 6) {
    return `(${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(3)}`;
  }

  return `(${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(
    3,
    6,
  )}-${nationalDigits.slice(6)}`;
};

const formatInternationalPhoneInput = (value: string) => {
  const digits = onlyDigits(value).slice(0, 15);
  if (!digits) return "+";

  if (digits.startsWith("1")) {
    const nationalDigits = digits.slice(1);
    return nationalDigits ? `+1 ${formatUsPhoneDigits(nationalDigits)}` : "+1";
  }

  const countryCode = digits.slice(0, Math.min(2, digits.length));
  const remainingDigits = digits.slice(countryCode.length);
  const groups = remainingDigits.match(/.{1,3}/g) ?? [];

  return groups.length > 0
    ? `+${countryCode} ${groups.join(" ")}`
    : `+${countryCode}`;
};

export const formatPhoneInput = (value: string) => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return "";

  if (trimmedValue.startsWith("+")) {
    return formatInternationalPhoneInput(trimmedValue);
  }

  const digits = onlyDigits(trimmedValue);
  const nationalDigits =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;

  return formatUsPhoneDigits(nationalDigits);
};
